import React from 'react'
import { FleetDataType } from 'src/core/models'
import FleetListDeleteBtn from './fleetListDeleteBtn'

const FleetListActionsColumn: React.FC<{ fleet: FleetDataType }> = ({ fleet }) => {
  return  <div className='centered'>
    {/* Delete */}
    <FleetListDeleteBtn fleet={fleet}/>
  </div>
}

export default FleetListActionsColumn
